import '~/pages/projects';
import { initHandRaiseLead } from 'ee/hand_raise_leads/hand_raise_lead';

initHandRaiseLead();
